import { render } from "./VideoPlayer.vue?vue&type=template&id=2874319e"
import script from "./VideoPlayer.vue?vue&type=script&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/dashcam_front/dashcam_front/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__